export default __webpack_public_path__ + "static/media/cvideo.d700cb12.png";